import PrimarySecondaryText from './PrimarySecondaryText';

export default PrimarySecondaryText;
